"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypeSnippetModels = void 0;
var ContentTypeSnippetModels;
(function (ContentTypeSnippetModels) {
    class ContentTypeSnippet {
        constructor(data) {
            Object.assign(this, data);
        }
    }
    ContentTypeSnippetModels.ContentTypeSnippet = ContentTypeSnippet;
})(ContentTypeSnippetModels = exports.ContentTypeSnippetModels || (exports.ContentTypeSnippetModels = {}));
//# sourceMappingURL=content-type-snippets.models.js.map